import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, firstValueFrom, lastValueFrom } from 'rxjs';
import { Customer, CustomerAuth } from '../../core/models/Customer';
import { UserApiService } from './user-api.service';
import { Address } from '../../core/classes/Address';
import { OrderRes } from '../../core/models/order/OrderRes';
import { OrderMode } from '../../core/enums/order/OrderMode';

@Injectable({
	providedIn: 'root',
})
export class UserStateService {
	get customer(): Customer {
		return this.customerAuth$.value?.customer;
	}

	get userInitialized() {
		return firstValueFrom(this.customerAuth$.pipe(filter(Boolean)));
	}

	get savedOrPrevDeliveryAddressesAvailable() {
		return this.savedAddresses.length || this.orders.find(o => o.preorder.type === OrderMode.DELIVERY);
	}

	get favoriteVenuesAvailable() {
		return true;
	}

	address$ = new BehaviorSubject<Address>(null);
	deliveryAddress$ = new BehaviorSubject<Address>(null);
	customerAuth$: BehaviorSubject<CustomerAuth> = new BehaviorSubject<CustomerAuth>(null);

	savedAddresses: Address[] = [];
	orders: OrderRes[] = [];

	private userApiSvc = inject(UserApiService);

	constructor() {
		this.init();
	}

	async init() {
		await this.reloadCustomer();

		this.savedAddresses = JSON.parse(localStorage.getItem('saved-addresses')) || [];
		this.customerAuth$.subscribe(async res => {
			if (!res) {
				const res = await lastValueFrom(this.userApiSvc.signInAnonymous()).catch(err => {
					localStorage.setItem('customer-auth', 'null');
				});
				if (res) this.customerAuth$.next(res);
				return;
			}

			localStorage.setItem('customer-auth', JSON.stringify(res));
			// if (this._order) {
			// 	this._order.userUid = this._customerAuth.customer.uid;
			// 	this.order.emit(this._order);
			// }
		});

		this.loadUserOrders();
	}

	async reloadCustomer() {
		let customerAuth: CustomerAuth | null = JSON.parse(localStorage.getItem('customer-auth'));
		if (customerAuth) {
			const res = await lastValueFrom(this.userApiSvc.getCustomer()).catch(err => null);
			if (res) customerAuth.customer = res;
			else customerAuth = null;
		}
		this.customerAuth$.next(customerAuth);
	}

	async loadUserOrders() {
		await this.userInitialized;
		this.orders = (await firstValueFrom(this.userApiSvc.getCustomerOrders(this.customer.uid))).withPayment;
	}

	saveAddress(address: Address, name: string) {
		address.name = name;
		this.savedAddresses.push(address);
		localStorage.setItem('saved-addresses', JSON.stringify(this.savedAddresses));
	}

	async toggleFavoriteVenue(venueId: string) {
		const customer = this.customerAuth$.value;

		if (this.customer.favoriteVenues.find(v => v === venueId)) {
			customer.customer = await lastValueFrom(this.userApiSvc.removeFavouritesVenue(this.customer._id, [venueId]));
		} else {
			customer.customer = await lastValueFrom(
				this.userApiSvc.addFavouritesVenue(this.customer._id, [...customer.customer.favoriteVenues, venueId])
			);
		}
		this.customerAuth$.next(customer);
	}
}
